<template>
  <div
    class="infowindow-wrapper"
    data-covers-map
  >
    <div class="infowindow">
      <!-- Close Control -->
      <div class="infowindow-control">
        <XMarkIcon
          id="close-infowindow"
          :weight="0.2"
          role="button"
          aria-label="Close InfoWindow"
          @click="$emit('close-infowindow')"
        />
        <v-tooltip
          text="Close InfoWindow"
          open-delay="800"
          activator="#close-infowindow"
        />
      </div>
      <div class="tab-tray-container">
        <slot name="tab-tray" />
      </div>
      <!-- Content -->
      <div class="content-container">
        <slot name="content" />
      </div>
      <!-- Attaching a class causes the thickness of the HR to go haywire, doing inline styling doesn't casuse this -->
      <hr style="width: 87%; margin-left: 24px; margin-top: 1px;">
      <!-- Footer -->
      <div class="footer-container">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
import XMarkIcon from '@/components/svgs/XMarkIcon.vue';

export default {
  name: 'InfoWindowPopup',
  components: {
    XMarkIcon,
  },
  emits: ['close-infowindow'],
};
</script>

<style lang="scss" scoped>
.infowindow-wrapper {
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.4));
  cursor: default;
  position: absolute;
  z-index: 500;
  left: 1.5vw;
  width: 97.5vw;
  top: 5px;

  @include main.respond(desktop) {
    top: 10px;
    // Yields to the Merge Review panel, which publishes its width on the document root. Timing matches Vuetify's slide.
    right: calc(10px + var(--merge-review-panel-width, 0px));
    transition: right 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    left: initial;
    width: 430px;
  }
}
.infowindow {
  background: white;
  border-radius: 5px;
  text-align: left;

  .infowindow-control {
    --control-size: 12px;
    margin-top: 1px;
    margin-right: 5px;
    position: absolute;
    right: 0;
    top: 0;
    width: var(--control-size);
    height: var(--control-size);
    cursor: pointer;
    z-index: 1;
  }
}
.tab-tray-container {
  padding-top: 10px;
}
.content-container {
  padding: 14px 24px 0px 24px;
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 85vh;
  margin-bottom: 10px;

  @include main.respond(desktop) {
    max-height: 81.5vh;
  }

  @include main.respond(tablet) {
    max-height: 75.5vh;
  }
}

.footer-container {
  display: flex;
  height: 32px;
  align-items: center;
  padding-left: 24px;
  padding-right: 29px;
  padding-bottom: 15px;
}
</style>
